define('views/pages/claims/collection-item',['require','underscore','views/base/view','models/modals/claim/index','views/modals/claim/index','text!templates/pages/claims/collection-item.ejs','helpers/claim','views/dialog'],function(require) {
    'use strict';

    var _ = require('underscore'),
        View = require('views/base/view'),
        ClaimModalModel = require('models/modals/claim/index'),
        ClaimModalView = require('views/modals/claim/index'),
        template = require('text!templates/pages/claims/collection-item.ejs'),
        claimHelper = require('helpers/claim'),
        Dialog = require('views/dialog');

    var ClaimTableRowView = View.extend({
        template: template,
        className: 'claim-item',
        tagName: 'tr',
        listen: {
            'change:deleted model': 'render',
            'change model': 'render'
        },
        initialize: function() {
            View.prototype.initialize.apply(this, arguments);
            this.delegate('click', 'a', this.openClaimModal);
            this.delegate('click', 'button', this.deleteClick);
        },
        render: function () {
            View.prototype.render.apply(this, arguments);
            this.$el[this.model.get('deleted') ? 'addClass' : 'removeClass']('deleted');
        },
        getTemplateData: function() {
            return _.defaults(View.prototype.getTemplateData.apply(this, arguments), claimHelper);
        },
        openClaimModal: function () {
            var model = this.model;
            var modalModel = new ClaimModalModel({});
            modalModel.on('action', function(action) {
                if (action==='submit') {

                    modalModel.content.set('items', modalModel.content.goods.pluck('dealId'));
                    modalModel.content.save();

                    var cur = {};
                    var m = modalModel.content;
                    cur[m.get('viewCurrencyId')] = m.get('viewCurrency');
                    cur[m.get('baseCurrencyId')] = m.get('baseCurrency');

                    model.set({
                        'type': modalModel.content.get('type'),
                        'currencyId': modalModel.content.get('currencyId'),
                        'currency': cur[modalModel.content.get('currencyId')],
                        'cost': modalModel.content.get('cost'),
                        'description': modalModel.content.get('description')
                    });
                }
            });

            this.subview('card', new ClaimModalView({ model: modalModel }));

            modalModel.content.set('claimId', this.model.get('id'));
            modalModel.content.load();
        },
        deleteClick: function(){
            var _this = this;
            Dialog.show('Удаление претензии', 'Вы действительно хотите удалить претензию?', Dialog.Buttons.YesNo)
                .attach(this)
                .submit(function() {
                    _this.model.del(function(error) {
                        if (error) {
                            Dialog
                                .show('Не удалось удалить претензию.', error === 'denied' ? 'Удаление данной претензии заблокировано.' : error, Dialog.Buttons.Close)
                                .attach(_this);
                        }
                    });
                });
        }
    });

    return ClaimTableRowView;
});

